import * as React from 'react';
import { Router } from "@reach/router";
import StepOne from 'views/StepOne/StepOne';
import StepTwo from 'views/StepTwo/StepTwo';
import StepThree from 'views/StepThree/StepThree';
import Layout from 'components/Layout/Layout';
import { GlobalStyle } from 'assets/GlobalStyles'
import { InvoiceProvider } from "store/context";

function App() {
   return (
      <>
      <GlobalStyle />
      <InvoiceProvider>
         <Router>
            <Layout path="/">
               <StepOne path="/" />
               <StepTwo path="/facturar" />
               <StepThree path="/archivos" />
            </Layout>
         </Router>
      </InvoiceProvider>
      </>
   ) 
}

export default App